import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { login } from '../data/user/actions';
import { saveActivationCode } from '../helpers/localStorage';
import { isEmailValid } from './../helpers/validation';
import Login from './LoginComponent';

class LoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      valid: true,
      passValid: true,
      invalidText: ''
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const passValid = !nextProps.auth.error;
    const loginErrorMessages = {
      'user apartment missing': 'Do twojego konta nie jest przypisany żaden lokal. Logowanie niemożliwe.',
      'user community missing': 'Do twojego konta nie jest przypisana żadna wspólnota. Logowanie niemożliwe.',
      'user account disabled': 'Konto jest nieaktywne.',
      'user apartment signed in future': 'Twój dostęp do mieszkania jeszcze się nie rozpoczął.'
    };
    const invalidText =
      loginErrorMessages[nextProps.auth.error] || 'Podane hasło jest nieprawidłowe.';
    this.setState({ passValid, invalidText: invalidText });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value.trim(),
      valid: true,
      passValid: true
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    const { username, password } = this.state;

    if (this.isFormValid()) {
      saveActivationCode(password);
      this.props.login(username, password);
    } else {
      this.setState({ valid: false });
    }
  };

  isFormValid = () => isEmailValid(this.state.username);

  render() {
    const { username, password, valid, passValid, invalidText } = this.state;
    const { from } = this.props.location.state || { from: { pathname: '/' } };

    if (this.props.auth.loggedIn) {
      return <Redirect to={from} />;
    }

    return (
      <Login
        username={username}
        password={password}
        valid={valid}
        passValid={passValid}
        invalidText={invalidText}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

LoginContainer.propTypes = {
  login: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.user.auth
});

const mapDispatchToProps = dispatch => ({
  login: (username, password) => {
    dispatch(login(username, password));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);
